import { render } from "./EditLieferantDetailsDialog.vue?vue&type=template&id=2d520e38&ts=true"
import script from "./EditLieferantDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./EditLieferantDetailsDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__